import React from 'react';
import { Card } from '../components/ui/card';
import { Brain, Heart, Activity, AlertCircle, TrendingUp, Zap } from 'lucide-react';
import SEO from '../components/SEO';

const MentalHealthEducation = () => {
  const topics = [
    {
      icon: <Brain size={40} />,
      title: 'Understanding Mood Disorders',
      content: 'Mood disorders affect emotional regulation, cognition, motivation, and daily functioning. Conditions such as depression and bipolar spectrum disorders require individualized, evidence-based treatment.'
    },
    {
      icon: <AlertCircle size={40} />,
      title: 'Psychiatric Medications & Side Effects',
      content: 'Psychiatric medications can impact appetite, metabolism, energy, sleep, and emotional regulation. Integrated care helps patients understand and manage these effects safely.'
    },
    {
      icon: <Activity size={40} />,
      title: 'Stress, Trauma & the Nervous System',
      content: 'Chronic stress and trauma affect the nervous system and contribute to anxiety, fatigue, mood instability, and burnout.'
    },
    {
      icon: <Zap size={40} />,
      title: 'Emotional Regulation & Impulse Control',
      content: 'Difficulties with emotional regulation and impulse control affect decision-making, eating behaviors, relationships, and treatment adherence.'
    },
    {
      icon: <Heart size={40} />,
      title: 'Mental Health & Metabolic Health',
      content: 'Mental and metabolic health are interconnected. Integrated care considers both neurological and physiological systems in treatment planning.'
    }
  ];

  return (
    <main className="pt-24 bg-[#FDFDFB]">
      <SEO 
        title="Mental Health Education"
        description="Learn about mood disorders, psychiatric medications, trauma, emotional regulation, and the connection between mental and metabolic health."
        keywords="mental health education, mood disorders, psychiatric medications, trauma treatment, emotional regulation, metabolic health"
      />

      <section className="py-16 bg-gradient-to-b from-[#f7f4f0] to-[#FDFDFB]">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-5xl font-bold text-[#7a8a72] mb-6">Mental Health Education</h1>
            <p className="text-xl text-[#3a3a3a]">
              Understanding your mental health is the first step toward healing
            </p>
          </div>

          <div className="max-w-5xl mx-auto space-y-8">
            {topics.map((topic, index) => (
              <Card key={index} className="p-8 bg-white border-[#d4cec5] hover:shadow-lg transition-all">
                <div className="flex items-start gap-6">
                  <div className="text-[#7a8a72] flex-shrink-0">
                    {topic.icon}
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-[#7a8a72] mb-3">{topic.title}</h2>
                    <p className="text-[#3a3a3a] leading-relaxed text-lg">{topic.content}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default MentalHealthEducation;